/** @type {import('../schema').ProcessDefinition} */
const facturasIa = {
  id: "facturas-ia",
  name: "Procesamiento de facturas con IA",
  category: "ia",
  outcome: "Cargar un gasto a partir de la foto/PDF de la factura, sin tipear.",
  trigger: "El Administrador sube una factura en Pagos del edificio.",
  actors: ["Administrador", "Bot Habi", "Sistema"],
  status: "COMPLETO",
  description:
    "El admin sube imagen/PDF; la IA de visión extrae emisor, RUT, ítems, totales, impuestos y fechas; el admin valida y corrige los campos de baja confianza; el sistema crea el gasto con su criterio de distribución, listo para el cierre.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "bot", actor: "Bot Habi" },
    { id: "sys", actor: "Sistema" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Sube la factura (imagen/PDF)", description: "Carga la foto o PDF de la factura en Pagos del edificio.", evidence: "src/screens/admin/PagosEdificio.jsx" },
    { id: "s2", laneId: "bot", type: "task", label: "Extrae datos con visión IA", description: "Extrae emisor, RUT, ítems, totales, impuestos y fechas.", evidence: "propia_agent/main.py (/process-invoice)" },
    { id: "s3", laneId: "admin", type: "decision", label: "¿La extracción coincide con la imagen?" },
    { id: "s4", laneId: "admin", type: "task", label: "Corrige campos de baja confianza", description: "Revisa y ajusta los campos dudosos antes de confirmar.", evidence: "src/screens/admin/PagosEdificio.jsx" },
    { id: "s5", laneId: "admin", type: "decision", label: "¿Proveedor conocido y RUT válido?" },
    { id: "s6", laneId: "admin", type: "task", label: "Da de alta el proveedor al vuelo", description: "Si el emisor es desconocido, lo crea (validando RUT)." },
    { id: "s7", laneId: "admin", type: "task", label: "Confirma proveedor y criterio de distribución", description: "Define a quién se cobra y el método de distribución del gasto." },
    { id: "s8", laneId: "sys", type: "end", label: "Crea el gasto (listo para el cierre)", description: "Guarda el gasto con su criterio; queda disponible para el cierre de mes.", evidence: "src/screens/admin/PagosEdificio.jsx" },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s1", label: "no (imagen borrosa)" },
    { from: "s3", to: "s4", label: "sí" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6", label: "desconocido" },
    { from: "s5", to: "s7", label: "conocido" },
    { from: "s6", to: "s7" },
    { from: "s7", to: "s8" },
  ],
};

export default facturasIa;
